import axios from 'axios'
import authcheck from '@/helpers/authcheck'
import {eventHub} from "@/store/eventHub";
import i18next from 'i18next'
import i18nextConfig from '@/helpers/i18next-config'

i18next.init(i18nextConfig)

interface ResponseData {
  status: number;
  config: Record<string, unknown>;
}

export interface ResponseError {
  response: ResponseData;
  config: {
    baseURL: string;
    url: string;
  };
}

export const hapiDomain = (): string => {
  if (process.env.VUE_APP_ENVIRONMENT === 'development') {
    return 'mt.freecycle.org:8000'
  }
  return window.location.host  // just the same as where we are. because everywhere but local dev, nginx sorts out the port.
}

export const vueDomain = (): string => {
  if (process.env.VUE_APP_ENVIRONMENT === 'development') {
    return 'mt.freecycle.org:8080'
  }
  return window.location.host
}

export const imagesDomain = (): string => {
  switch (process.env.VUE_APP_ENVIRONMENT) {
    case 'production':
      return 'images.freecycle.org'
    case 'staging':
      return 'images.freecycle.org'
    case 'development':
      return 'images.freecycle.org'
    default:
      return 'images.freecycle.org'
  }
}

export const API = axios.create({
  baseURL: 'https://' + hapiDomain(),
  withCredentials: true,
  validateStatus: function (status) {
    return status < 500; // maybe need to play with this... this controls if axios rejects promise...
  }
})

// This pops up a snackbar error when Axios gets an error response, or if there's some other error, alerts in a different way.
export const handleError = (e: ResponseError | unknown): void => {
  let text
  const maybe = e as { response?: { status?: number }; config?: { baseURL?: string; url?: string } }
  if (!maybe || !maybe.response) {
    authcheck.httpCodeSwitch(500)
    const baseURL = maybe && maybe.config && maybe.config.baseURL ? maybe.config.baseURL : ''
    const url = maybe && maybe.config && maybe.config.url ? maybe.config.url : ''
    text = `${i18next.t('backend API seems to be down.')} ${baseURL}/${url}: ${String(e)}`
    text = text + i18next.t('Sorry, please reload, or try again later. If problem persists, use help beacon below.');
  } else {
    const status = typeof maybe.response.status === 'number' ? maybe.response.status : 500
    authcheck.httpCodeSwitch(status)
    const baseURL = maybe && maybe.config && maybe.config.baseURL ? maybe.config.baseURL : ''
    const url = maybe && maybe.config && maybe.config.url ? maybe.config.url : ''
    text = `${i18next.t('Error talking to backend API on')} ${baseURL}/${url}: ${String(e)}`
  }

  eventHub.$emit('triggerSnackbar', {
    color: 'error',
    text,
    timeout: 12000
  })
}
